export const IMPORTSTUDENT_IMPORT = 'IMPORTSTUDENT_IMPORT';
export const IMPORTSTUDENT_ERROR = 'IMPORTSTUDENT_ERROR';
export const IMPORTSTUDENT_CLEAR_ERROR = 'IMPORTSTUDENT_CLEAR_ERROR';
export const IMPORTSTUDENT_CLEAR_DATA = 'IMPORTSITE_CLEAR_DATA';
export const IMPORTSTUDENT_GET_CONFIG = 'IMPORTSTUDENT_GET_CONFIG';
export const IMPORTSTUDENT_CONFIG_ERROR = 'IMPORTSTUDENT_CONFIG_ERROR';
export const GET_LANGUAGES = 'GET_LANGUAGES';
export const GET_LANGUAGES_ERROR = 'GET_LANGUAGES_ERROR';
export const GET_MAPPING_DATA = 'GET_MAPPING_DATA';
export const GET_MAPPING_DATA_ERROR = 'GET_MAPPING_DATA_ERROR';
export const ADD_LANGUAGE_MAPPING_DATA = 'ADD_LANGUAGE_MAPPING_DATA';
export const CLEAR_MAPPING_DATA = 'CLEAR_MAPPING_DATA';
export const CLEAR_ADDED_MAPPING_DATA = 'CLEAR_ADDED_MAPPING_DATA';
export const REMOVE_MAPPING_DATA = 'REMOVE_MAPPING_DATA';
export const ADD_MEAL_MAPPING_DATA = 'ADD_MEAL_MAPPING_DATA';
export const ADD_COLUMN_MAPPING = 'ADD_COLUMN_MAPPING';
export const REMOVE_COLUMN_MAPPING = 'REMOVE_COLUMN_MAPPING';

export const CLEAR_CUSTOM_MAPPING_DATA = 'CLEAR_CUSTOM_MAPPING_DATA';

export const GET_LANGUAGE_MAPPING_DATA = 'GET_LANGUAGE_MAPPING_DATA';
export const GET_MEAL_MAPPING_DATA = 'GET_MEAL_MAPPING_DATA';
export const POST_IMPORTSTUDENTS = 'POST_IMPORTSTUDENTS';
export const POST_IMPORTSTUDENTS_ERROR = 'POST_IMPORTSTUDENTS_ERROR';
export const POST_IMPORTSTUDENTS_CLEAR_DATA = 'POST_IMPORTSTUDENTS_CLEAR_DATA';

export const IMPORTSTUDENT_HEADER = 'IMPORTSTUDENT_HEADER';
export const IMPORTSTUDENT_HEADER_ERROR = 'IMPORTSTUDENT_HEADER_ERROR';
export const IMPORT_STUDENT = 'IMPORT_STUDENT';
export const IMPORT_STUDENT_ERROR = 'IMPORT_STUDENT_ERROR';

export const IMPORT_STUDENT_READY = 'IMPORT_STUDENT_READY';

export const GET_IMPORT_SCHEDULE = 'GET_IMPORT_SCHEDULE';
export const GET_IMPORT_SCHEDULE_ERROR = 'GET_IMPORT_SCHEDULE_ERROR';
export const POST_IMPORT_SCHEDULE = 'POST_IMPORT_SCHEDULE';
export const POST_IMPORT_SCHEDULE_ERROR = 'POST_IMPORT_SCHEDULE_ERROR';
export const SET_SITE_MAPPING_DATA = 'SET_SITE_MAPPING_DATA';
export const SET_GRADE_MAPPING_DATA = 'SET_GRADE_MAPPING_DATA';
export const SET_GRADES = 'SET_GRADES';
export const GET_GRADES_FETCHING_ERROR = 'GET_GRADES_FETCHING_ERROR';

export const GET_IMPORTSTUDENT_SETTINGS = 'GET_IMPORTSTUDENTS_SETTINGS';
export const REMOVE_IMPORTSTUDENT_SETTINGS = 'REMOVE_IMPORTSTUDENTS_SETTINGS';
export const IMPORTSTUDENT_SETTINGS_ERROR = 'IMPORTSTUDENTS_SETTINGS_ERROR';



// WEBPACK FOOTER //
// ./src/pages/importstudents/state/types.js